import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { iconScalableStyles } from "@starter/Themes/common/mixins/icon";
import { css } from "styled-components";

export default {
    defaultProps: {
        cssOverrides: {
            currentButton: css`
                background-color: ${getColor("primary")};
                color: ${getColor("primary.contrast")};
            `,
        },
        buttonProps: {
            css: css`
                border: none;
                background-color: ${getColor("common.background")};
                color: ${getColor("text.main")};

                ${IconWrapper} {
                    ${iconScalableStyles("1.1em")}
                    justify-content: center;
                    color: ${getColor("text.main")};
                }

                &:disabled {
                    background-color: ${getColor("common.background")};
                    color: ${getColor("text.main")};

                    ${IconWrapper} {
                        color: inherit;
                    }
                }

                &:not(:disabled) {
                    &:hover,
                    &:active {
                        background-color: ${getColor("common.border")};
                        color: ${getColor("text.main")};

                        ${IconWrapper} {
                            color: inherit;
                        }
                    }
                }
            `,
        },
    },
};
